import { Stack, Typography } from '@mui/material';
import DashboardCard from '/@/components/bayer/dashboard-card';
import useUnitProvider from '/@/core/context/unit';
import { useGrowersDashboardReports } from '/@/hooks/dashboards';
import { _ } from '/@/locale';
import { objectEntries } from '/@/utils';
import type { NodeScopeFilters } from '/@/utils/node-scope';
import { getCrops } from '../../../hooks/crops';

const CropSurfaceReportRankingDashboardCard = ({
    growerNodeId,
    year,
    nodeScope,
}: {
    growerNodeId?: number;
    year: number;
    nodeScope: NodeScopeFilters;
}) => {
    const units = useUnitProvider();
    const crops = getCrops();

    const { data: dashboardReports, isValidating } = useGrowersDashboardReports({
        year,
        node: growerNodeId,
        ...nodeScope,
    });
    return (
        <DashboardCard
            title={_('Distribución de Cultivos')}
            isLoading={isValidating}
            subtitle={_('Superficie cosechada por cultivo')}
            spacing={0.5}
        >
            <Stack direction='column' spacing={2} sx={{ height: 'fill-available', pt: 1.5 }}>
                {objectEntries((dashboardReports?.harvest?.areaByCrop ?? {}) as Record<string, number>).map(
                    ([crop, area]) => (
                        <Stack key={crop} direction='row' spacing={2} justifyContent='space-between'>
                            <Stack direction='row' spacing={1} alignItems='center'>
                                {crops[crop as keyof typeof crops]?.getChip({ text: '' })}
                            </Stack>
                            <Typography
                                fontWeight={700}
                                color='primary'
                                variant='h6'
                            >{`${units.toArea(area as number, 'corn')}`}</Typography>
                        </Stack>
                    )
                )}
            </Stack>
        </DashboardCard>
    );
};

export default CropSurfaceReportRankingDashboardCard;
